import type { FieldValues, Path } from "react-hook-form";
import type { ResourceSelectFieldProps } from "~/components/Form";
import { ResourceSelectField } from "~/components/Form";
import {
  useWorkflowQueryOptionsFactory,
  useWorkflowsQueryOptionsFactory,
} from "../api";

export function WorkflowSelect<
  TFieldValues extends FieldValues,
  TName extends Path<TFieldValues>,
>(props: ResourceSelectFieldProps<TFieldValues, TName>) {
  const createWorkflowsQueryOptions = useWorkflowsQueryOptionsFactory();
  const createWorkflowQueryOptions = useWorkflowQueryOptionsFactory();

  return (
    <ResourceSelectField
      {...props}
      createListQueryOptions={(text) =>
        createWorkflowsQueryOptions({
          nameLike: text,
          limit: 5,
          sort: "asc",
          order: "name",
        })
      }
      createFetchQueryOptions={createWorkflowQueryOptions}
      selectOption={(workflow) => ({
        value: workflow.id,
        label: workflow.name,
      })}
    />
  );
}
